// @ts-ignore
import Router, { withRouter } from "next/router";
import React, { useState, useCallback, useEffect } from "react";
// @ts-ignore
import isMobile from "../helpers/isMobile";
import NavLink from "./NavLink";
import NavLinkOption from "./NavLinkOption";
import styles from "./Tabs.module.css";
import { Link } from "../../types/Link";

export type Tab = {
  labelId: string;
  link: Link;
  isSelectedMatchers: Link[];
};

type TabsProps = {
  router: Router;
  tabs: Tab[];
};

export function Tabs({ router, tabs }: TabsProps) {
  // Calculate isMobile immediately on first render (works in both SSR and CSR)
  // Lazy initialization prevents calling isMobile() on every render
  const [mobile, setMobile] = useState(() => {
    // During SSR, default to mobile (true) for progressive enhancement
    // This ensures mobile users get optimized UI even if JavaScript fails
    if (typeof window === "undefined") {
      return true;
    }
    return isMobile();
  });

  // Sync with window resize events (but don't set initial state here)
  useEffect(() => {
    const handleResize = () => {
      setMobile(isMobile());
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const onChange = useCallback(
    (
      event:
        | React.ChangeEvent<HTMLSelectElement>
        | React.FormEvent<HTMLDivElement>,
    ) => {
      const { currentTarget } = event;

      if (!("selectedIndex" in currentTarget)) {
        return;
      }

      if (currentTarget.selectedIndex < 0) {
        return;
      }

      const selectedItem = currentTarget.item(currentTarget.selectedIndex);
      if (selectedItem) {
        // @ts-ignore
        router.push(selectedItem.value, selectedItem.dataset.as);
      }
    },
    [router],
  );

  const ListTag = mobile ? "select" : "div";
  const ItemTag = mobile ? NavLinkOption : NavLink;

  if (tabs.length === 0) {
    return null;
  }

  return (
    <ListTag
      className={styles.root}
      onChange={(e: any) => mobile && onChange(e)}
    >
      {tabs.map(
        ({ link, labelId, isSelectedMatchers }) =>
          link.canAccess && (
            <ItemTag
              key={labelId}
              activeClassName={styles.isActive}
              className={styles.tab}
              isSelectedMatchers={isSelectedMatchers}
              labelId={labelId}
              link={link}
            />
          ),
      )}
    </ListTag>
  );
}

export default withRouter(Tabs);
